<template>
  <div class="w-full h-full">
    <!-- svg -->
    <iframe
      class="w-full h-full"
      id="mainSvgIframe"
      ref="mainSvgIframe"
      :src="`/lib/svgView/index.html?file=${mainResourceUrl}?fileId=${mainFileId}`"
      v-if="mainFileType.toLowerCase() === 'svg'"
    ></iframe>
    <!-- 图片 -->
    <div
      id="mainImgDom"
      class="w-full h-full flex-row-center-center"
      v-else-if="imgTypeList.includes(mainFileType.toLowerCase())"
    >
      <img id="mainImg" :src="mainResourceUrl" class="w-full h-full" />
    </div>
    <!-- tif -->
    <div
      id="mainImgDom"
      class="w-full h-full flex-row-center-center"
      v-else-if="mainFileType.toLowerCase() === 'tif'"
      v-loading="loadingTif"
    >
      <img id="mainImg" :src="tifUrl" class="w-full h-full" />
    </div>
    <!-- txt -->
    <div
      v-else-if="mainFileType.toLowerCase() === 'txt'"
      class="w-full h-full overflow-auto text-white"
    >
      {{ txtContent }}
    </div>
    <!-- pdf -->
    <iframe
      :src="defaultFileId"
      id="mainPdfIframe"
      @load="mainFileLoading = false"
      v-else-if="mainFileType.toLowerCase() === 'pdf' && defaultFileId.includes('http')"
      class="w-full h-full"
    ></iframe>
    <iframe
      :src="`/lib/pdfjs/web/viewer.html?file=${mainResourceUrl}#${fileLocationByComponent}`"
      id="mainPdfIframe"
      @load="mainFileLoading = false"
      v-else-if="mainFileType.toLowerCase() === 'pdf' && !defaultFileId.includes('http')"
      class="w-full h-full"
    ></iframe>
    <!-- ht -->
    <iframe
      v-else-if="mainFileType.toLowerCase() === 'wizdrawing'"
      @load="mainFileLoading = false"
      ref="leftHtFrame"
      :src="htPage"
      class="h-full w-full"
    ></iframe>
    <!-- mp4, mov -->
    <video
      v-else-if="_.includes(['mp4', 'mov'], mainFileType.toLowerCase())"
      :src="mainResourceUrl"
      class="w-full h-full"
      id="video"
      controls
      ref="videoPlayer"
    ></video>
    <!-- pr -->
    <ModelView
      v-else-if="mainFileType.toLowerCase() === 'pr'"
      class="w-full h-full"
      :fileId="fileObj.fileIdOrigin"
      :md5="fileObj.md5"
    ></ModelView>
    <!-- 其他的文件类型 -->
    <iframe
      v-else
      :src="mainResourceUrl"
      class="h-full w-full"
      @load="mainFileLoading = false"
    ></iframe>
  </div>
</template>

<script>
import Tiff from 'tiff.js'
import axios from 'axios'
import HandoverService from '../../../service/HandoverService'
import EventBus from '../../../assets/js/componentMethods/EventBus'

const ModelView = () => {
  return import('./modelView')
}
export default {
  props: {
    dialogForm: {
      type: Object,
      defalut: '',
    },
    player: {
      type: Object,
      default: () => {},
    },
    standardId: {
      type: String,
      default: '',
    },
  },
  components: {
    ModelView,
  },
  data() {
    return {
      fileObj: {},
      mainFileType: '',
      mainResourceUrl: '',
      mainFileId: '',
      defaultFileId: '',
      imgTypeList: ['jpeg', 'bmp', 'jpg', 'png', 'gif', 'webp'], // 图片类型
      tifUrl: '',
      loadingTif: false, // 加载tif文件
      fileLocationByComponent: 'page=1&zoom=auto', // pdf加载完成时需要定位的位置
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      mainFileLoading: false,
      imgViewParams: {
        zoomVal: 1,
      }, // 图片缩放参数
      code: '',
      txtContent: '', // txt类型文件
    }
  },
  watch: {
    'fileObj.fileName': {
      handler(fileName) {
        this.mainFileType = fileName.substring(fileName.lastIndexOf('.') + 1)
        if (this.mainFileType.toLowerCase() === 'svg') {
          this.mainFileLoading = true
        }
        window.mainFileType = this.mainFileType.toLowerCase()
      },
    },
    'fileObj.fileId': {
      handler(fileId) {
        const baseUrl = _.get(
          Wiz,
          'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config'
        ).handoverServerConfig.baseUrl
        this.mainResourceUrl = `${baseUrl}/api/std/file/${fileId}`
        this.mainFileId = fileId
        this.defaultFileId = this.fileObj.defaultFileId
      },
    },
    'fileObj.nodeCode': {
      handler(nodeCode) {
        this.code = nodeCode
      },
    },
    mainResourceUrl(url) {
      if (!url) {
        return
      }
      if (this.mainFileType.toLowerCase() === 'wizdrawing') {
        this.htLoad(url, 'left')
      }
      if (this.mainFileType.toLowerCase() === 'tif') {
        this.tifToImg(url)
      }
      if (this.mainFileType.toLowerCase() === 'txt') {
        this.handleTXT(url)
      }
    },
  },
  computed: {
    cloudRender() {
      return cloudRender
    },
  },
  methods: {
    // tif转img
    tifToImg(path) {
      this.loadingTif = true
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'arraybuffer'
      xhr.open('GET', path)
      xhr.onload = () => {
        Tiff.initialize({
          TOTAL_MEMORY: 200000000,
        })
        const tiff = new Tiff({ buffer: xhr.response })
        this.tifUrl = tiff.toDataURL()
      }
      xhr.send()
      this.loadingTif = false
    },
    // 加载ht图
    htLoad(url, frame) {
      try {
        this.$refs[`${frame}HtFrame`].contentWindow.init(url)
      } catch (error) {
        setTimeout(() => {
          this.htLoad(url, frame)
        }, 500)
        return
      }
      const $window = this.$refs[`${frame}HtFrame`].contentWindow
      if (frame === 'left') {
        $window.htFileId = this.mainFileId
      } else {
        $window.htFileId = this.fileId
      }
      $window.currentScreen = frame
    },
    // 处理txt文件
    handleTXT(url) {
      axios.get(url, { responseType: 'text' }).then((res) => {
        this.txtContent = res.data
      })
    },
    // 点击节点(与三维联动)
    async handleNodeClick(code) {
      if (code) {
        // 通过位号查找节点
        const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
        console.log(codeInfo, '111')
        if (codeInfo && codeInfo.item) {
          // 设置当前选中节点，不触发事件
          this.player.Native.ModelTree.setSelectItem(codeInfo.item)
          // 设置点选时其他节点半透明
          this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', 0.4)
          // 外层添加包裹盒子
          this.player.Native.Settings.set('pickup.highlight', 'bool', true)
          this.player.Native.Settings.set('show.select.box', 'bool', true)
          // 计算节点包围盒
          const { aabb, localMatrix } = await this.player.Native.ModelTree.calcItemAabb(
            codeInfo.item
          )
          // 相机移动到包围盒位置
          this.player.Native.Camera.addMoveToAabb(aabb, localMatrix, 5, 1.1, 2)
        }
      }
    },
    // 获取位号的code
    async getCodeId(id) {
      const [err, res] = await HandoverService.getCodeId({
        standardId: this.standardId,
        dataId: id,
        cateCode: 'Tag',
      })
      if (!err && res && res.code === 0 && res.data) {
        Object.keys(res.data).forEach((key) => {
          const prefix = key.split('.')[1]
          if (prefix.toLowerCase() === 'code') {
            this.handleNodeClick(res.data[key])
          }
        })
      }
    },
    modelNodeHandler(val) {
      if (val?.code) {
        console.log('🚀 svgHotTrigger', val.code)
        window.svgData[window.location.href].svgHotTrigger(val.code)
      }
    },
  },
  created() {
    this.fileObj = this.dialogForm
  },
  async mounted() {
    // if (this.mainFileType === 'svg') {
    // 监听svg的单击事件，与三维联动
    window.addEventListener('message', (el) => {
      console.log('svgTrigger', el)
      this.$emit('svgTrigger', el.data)
      if (el.data.type === 'svgTrigger') {
        if (el.data.tagId) {
          // 根据id找code
          this.getCodeId(el.data.tagId)
          return
        }
        if (el.data.code) {
          this.handleNodeClick(el.data.code)
          // this.handleNodeClick('排污管A1#') // 测试用
        }
      }
    })
    EventBus.$on('updateModelNode', this.modelNodeHandler)
    // }
  },
  beforeDestroy() {
    EventBus.$off('updateModelNode', this.modelNodeHandler)
  },
}
</script>
